module.exports = __webpack_public_path__ + "media/vending-cut.216fd9ba.mp3";